import AssortmentManagementIcon from "@material-ui/icons/CreateOutlined";
import CropFreeIcon from "@material-ui/icons/CropFree";
import MenuIcon from "@material-ui/icons/Menu";
import ProfileIcon from "@material-ui/icons/Person";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import "./BottomNavBar.scss";

function BottomNavBar(props) {
  if (props.hub) {
    return (
      <footer className="footer">
        <nav className="footer-list">
          <ul className="footer-list">
            <Link to="/menu" style={{ textDecoration: "none", color: "black" }}>
              <li>
                <MenuIcon />
              </li>
            </Link>
            <Link
              to="/scanner"
              style={{ textDecoration: "none", color: "black" }}
            >
              <li>
                <CropFreeIcon />
              </li>
            </Link>
            <Link
              to="/assortment-management"
              style={{ textDecoration: "none", color: "black" }}
            >
              <li>
                <AssortmentManagementIcon />
              </li>
            </Link>
            <Link
              to="/profile"
              style={{ textDecoration: "none", color: "black" }}
            >
              <li>
                <ProfileIcon />
              </li>
            </Link>
          </ul>
        </nav>
      </footer>
    );
  } else {
    return (
      <footer className="footer">
        <nav className="footer-list">
          <ul className="footer-list">
            <Link to="/menu" style={{ textDecoration: "none", color: "black" }}>
              <li>
                <MenuIcon />
              </li>
            </Link>
            <Link
              to="/assortment-management"
              style={{ textDecoration: "none", color: "black" }}
            >
              <li>
                <AssortmentManagementIcon />
              </li>
            </Link>
            <Link
              to="/profile"
              style={{ textDecoration: "none", color: "black" }}
            >
              <li>
                <ProfileIcon />
              </li>
            </Link>
          </ul>
        </nav>
      </footer>
    );
  }
}

function mapStateToProps(state) {
  return {
    hub: state.login.login_data.hub,
  };
}

export default connect(mapStateToProps, {})(BottomNavBar);
